import type { Export } from '../../types';
import addJournalData from '../common/addJournalData';

export default (exports: Export[]) =>
  addJournalData(exports, {
    // TODO add me
    presentingComplaint: 'TODO',
    snomedCode: 'TODO',
  });
